import Auth from "../../../Pages/Public/Login/Auth";
import Unauthorised from "../../../Pages/Public/Unauthorised";
import Login from "../../../Pages/Public/Login/Login";
import NoRights from "../../../Pages/Public/NoRights";
import OutOfService from "../../../Pages/Public/OutOfService/OutOfService";
import { LoginCallback } from "@okta/okta-react";
import NotSupported from "../../../Pages/Public/NotSupported/NotSupported";
import { IRoute } from "./Routes";
import AccessDenied from "../../../Pages/Public/AccessDenied";

export default class PublicRoutes
{
    public routes: IRoute<any>[] = [
        {
            isPublic: true,
            requiredRights: [],
            path: "/norights",
            component: NoRights,
        },
        {
            isPublic: true,
            requiredRights: [],
            path: "/out-of-service",
            component: OutOfService,
        },
        {
            isPublic: true,
            requiredRights: [],
            path: "/unauthorised",
            component: Unauthorised,
        },
        {
            isPublic: true,
            requiredRights: [],
            path: "/login",
            component: Login
        },
        {
            isPublic: true,
            requiredRights: [],
            path: "/implicit/callback",
            component: LoginCallback,
        },
        {
            isPublic: true,
            requiredRights: [],
            path: "/auth",
            component: Auth
        },
        {
            isPublic: true,
            requiredRights: [],
            path: "/not-supported",
            component: NotSupported
        },
        {
            requiredRights: [],
            path: "/access-denied",
            component: AccessDenied
        },
    ];
}
